import React from 'react'
import AboutUs from '../components/AboutUs/AboutUs'
import NavAbout from '../components/NavAbout/NavAbout'

const Aboutus = () => {
  return (
    <div>
      <NavAbout />
      <AboutUs />
    </div>
  )
}

export default Aboutus